/* src/app/components/session-info/charge-info/charge-info.component.scss */
ion-text {
  white-space: nowrap;
}
/*# sourceMappingURL=charge-info.component.css.map */
